<script setup lang="ts">
import { useKnowledgeBase } from '~/composables/useKnowledgeBase'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const knowledgeBase = useKnowledgeBase()
const route = useRoute()

// Hide button when on knowledge base page
const isKnowledgeBasePage = computed(() => route.path === '/knowledge-base')

function openKnowledgeBase() {
  // Simply open the modal - the sidebar will handle fetching entries
  knowledgeBase.openModal()
}
</script>

<template>
  <div v-if="!isKnowledgeBasePage">
    <button
      class="fixed right-4 bottom-20 z-50 flex items-center justify-center w-12 h-12 rounded-full bg-primary-600 hover:bg-primary-700 shadow-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
      type="button"
      title="Knowledge Base"
      @click="openKnowledgeBase"
    >
      <div class="i-icon-park-outline:help text-white text-2xl" />
    </button>
  </div>
</template>
